/**
 * @getcreatr/logger
 *
 * Centralized logging abstraction for the Creatr platform.
 * Supports multiple providers (Console, etc.) with a unified API.
 */

// Main exports
export { Logger } from './logger';
export { createLogger } from './config';

// Providers
export { BaseLoggerProvider } from './providers/base';
export {
  ConsoleProvider,
  type ConsoleProviderOptions,
} from './providers/console';
export { CompositeProvider } from './providers/composite';
export {
  DatadogProvider,
  type DatadogProviderOptions,
} from './providers/datadog';

// Types
export type {
  LogLevel,
  Attributes,
  SpanOperation,
  SpanOptions,
  Span,
  ExceptionContext,
  LoggerConfig,
  LoggerProvider,
} from './types';
